

































































import AppCard from '~/components/AppCard.vue'
import AppButton from '~/components/AppButton.vue'
import AddCenterDialog from '~/components/center/AddCenterDialog.vue'
import CenterDialog from '~/components/center/CenterDialog.vue'
import { isAdmin } from '~/middleware/isAdmin'
import { Role } from '../../../shared/Role'
import Vue from 'vue'
import { sortAlphabetically, filterList } from '~/helper/Utilities'

export default Vue.extend({
  components: {
    AppCard,
    AddCenterDialog,
    CenterDialog,
    AppButton,
  },
  middleware: isAdmin,
  props: ['centers', 'title', 'subtitle', 'viewOnly'],
  data: () => ({
    search: '',
    Role,
    showDialog: false,
    selectedCenter: { name: '...' } as any,
  }),
  computed: {
    filteredCenters(): any[] {
      return sortAlphabetically(filterList(this.centers, this.search), 'name')
    },
  },
  methods: {
    showCenterDialog(center: any) {
      this.selectedCenter = center
      this.showDialog = true
    },
    deleteCenter(center: any) {
      this.centers.splice((this.centers.indexOf(center)), 1)
    }
  },
})
